// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__33hk-","loaderOuter":"PageOverlayLoader_loaderOuter__3tht5"};